<template>
  <section
    class="booking-details margin-bottom-xs-2 margin-bottom-md-0"
    v-if="!booking.completed"
  >
    <div class="margin-top-xs-1">
      <div class="alert alert-nk">
        <p v-html="activities.selected.activity_name"></p>
        <p v-html="selectedSlot.date + ' klockan ' + selectedSlot.time"></p>
        <p v-html="selectedSlot.location_name"></p>
        <p v-html="formatProviderNameInList(selectedSlot.terapeut_sign)"></p>
        <!-- <div v-if="activities.selected.activity_group_id == '3'">
          <p class="margin-bottom-xs-1 margin-top-xs-1">
            <strong>Förstagångskunder:</strong> <br />
            Konsultation krävs senast 48h innan utförd behandling.
          </p>
          <p>
            <strong>Befintliga kunder:</strong> <br />
            Konsultation krävs om det passerat över 6 mån sedan din senaste
            injektionsbehandling.
          </p>
        </div> -->
        <div v-if="infoBox" v-html="infoBox" class="margin-top-xs-1"></div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  computed: {
    ...mapState(['activities', 'selectedSlot', 'booking', 'infoBox']),
  },
  mounted() {
    // Assuming activities.selected.activity_id is set somewhere in your application
    if (this.activities.selected.activity_id) {
      // Dispatch action to fetch infoBox content for the selected activity
      this.fetchInfoBox(this.activities.selected.activity_id);
    }
  },
  methods: {
    ...mapActions(['getInfoBox']),
    async fetchInfoBox(activityId) {
      try {
        // Dispatch action to fetch infoBox content using Vuex action
        await this.getInfoBox(activityId);
      } catch (error) {
        console.error('Error fetching infoBox:', error);
      }
    },
    formatProviderNameInList(name) {
      return this.$store.getters.formatProviderNameInList(name);
    },
  },
};
</script>
